import Service from '../../../api/api-service';
import { ApiUrl } from '../../../api/api-url';
import * as config from '../../../common/config';

const service = new Service();

export const GetListAll = (data) => {
    const params = new URLSearchParams();

    data.name && params.append('name', data.name);
    data.status && params.append('status', data.status);
    data.sorting && params.append('sorting', data.sorting);
    data.pageIndex && params.append('pageIndex', data.pageIndex);
    data.pageSize && params.append('pageSize', data.pageSize);

    return service
        .get('api/admin/BookOrder/get-list', params)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};

export const Create = (body) => {
    return service
        .post('api/cms/BookOrder/create', body)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};

export const Update = (body) => {
    return service
        .put('api/admin/BookOrder/update', body)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};

export const Delete = (id) => {
    return service
        .delete('api/admin/BookOrder/delete?id=' + id)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};

export const GetDetail = (id) => {
    return service
        .get('api/admin/BookOrder/get-detail?id=' + id)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};

export const UpdateStatus = (id, status) => {

    return service
        .put('api/admin/BookOrder/update-status?id=' + id + '&status=' + status)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            throw err;
        });
};